import { useCallback, useMemo } from "react";
import {
  getUniqueDescriptionsFromTransactions,
  getUniquePaidToFromTransactions,
} from "../helpers/utils";
import useAllTransactions from "./useAllTransactions";

export default function useAutoComplete() {
  const { allTransactions } = useAllTransactions();

  // Función reutilizable para mapear y limpiar los valores
  const mapAndTrim = (values: any[]) =>
    values
      .map((value) => value?.trim())
      .filter(Boolean)
      .sort()
      .map((value) => ({
        label: value,
        value: value,
      }));

  // Obtener las opciones de 'payTo' únicas
  const payTo = useMemo(
    () =>
      mapAndTrim(
        getUniquePaidToFromTransactions({ transactions: allTransactions }) || []
      ),
    [allTransactions]
  );

  // Obtener etiquetas únicas
  const tags = useMemo(() => {
    const uniqueTags = new Set();
    allTransactions?.forEach?.((transaction: any) => {
      if (transaction.tags?.length) {
        transaction?.tags?.forEach?.((tag: string) => uniqueTags.add(tag));
      }
    });
    return Array.from(uniqueTags).sort();
  }, [allTransactions]);

  // Obtener las descripciones únicas
  const descriptions = useMemo(
    () =>
      mapAndTrim(
        getUniqueDescriptionsFromTransactions({
          transactions: allTransactions,
        }) || []
      ),
    [allTransactions]
  );

  // Función para obtener la categoría por descripción
  const getCategoryByDescription = useCallback(
    ({ description }: { description: string }) => {
      const res = allTransactions?.find(
        ({ description: originalDescription }: { description: string }) =>
          originalDescription?.toLowerCase()?.trim() ===
          description?.toLowerCase()?.trim()
      );
      return res?.category || "";
    },
    [allTransactions]
  );

  return {
    allPayToList: payTo,
    allTagList: tags,
    allDescriptionList: descriptions,
    getCategoryByDescription,
  };
}
